import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import QnaBoardList from './QnaBoardList';
import QnaBoardDetail from './QnaBoardDetail';

@inject(({ commonStore, qnaBoardStore }) => ({
  commonStore: commonStore,
  sessionLoginInfo: commonStore.sessionLoginInfo,
  setCommonStoreInfo: qnaBoardStore.setCommonStoreInfo,
  
  onClear: qnaBoardStore.onClear,
  viewMode: qnaBoardStore.viewMode,
  onViewMode: qnaBoardStore.onViewMode,
  valCondition: qnaBoardStore.valCondition,
  qnaBoardList: qnaBoardStore.qnaBoardList,
  pageInfo: qnaBoardStore.pageInfo,
  detailData: qnaBoardStore.detailData,
  onChangValue: qnaBoardStore.onChangValue,
  disQnaBoardDetail: qnaBoardStore.disQnaBoardDetail,
  disQnaBoardList: qnaBoardStore.disQnaBoardList,
  addQnaBoardInfo: qnaBoardStore.addQnaBoardInfo,
  modQnaBoardInfo: qnaBoardStore.modQnaBoardInfo,
  delQnaBoardInfo: qnaBoardStore.delQnaBoardInfo,
  disQnaBoardPwChk: qnaBoardStore.disQnaBoardPwChk,

  // 댓글
  addQnaBoardCommentsInfo: qnaBoardStore.addQnaBoardCommentsInfo,
  modQnaBoardCommentsInfo: qnaBoardStore.modQnaBoardCommentsInfo,
  delQnaBoardCommentsInfo: qnaBoardStore.delQnaBoardCommentsInfo,
}))
@observer
class QnaBoard extends Component {

  UNSAFE_componentWillMount() {
    this.props.setCommonStoreInfo(this.props.commonStore);
    this.props.onClear();
    this.props.disQnaBoardList(1);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.viewMode !== this.props.viewMode) {
      if (nextProps.viewMode === 'list') {
        this.props.history.push('/qnaBoard');
      } else {
        this.props.history.push('/qnaBoard/'+nextProps.viewMode);
      }
    }
    if(nextProps.location.pathname !== this.props.location.pathname) {
      // 뒤로가기 버튼을 눌러서 주소가 바뀌었을 때 viewMode 상태가 detail 이면 list로 변경해준다.
      if (nextProps.location.pathname.lastIndexOf("/") === 0) {
        if (nextProps.viewMode !== 'list') {
          this.props.onViewMode("list");
        }
      } else {
        let pageMode = nextProps.location.pathname.substring(nextProps.location.pathname.lastIndexOf("/")+1);
        // console.log("pageMode", pageMode);
        if (nextProps.viewMode !== pageMode) {
          this.props.onViewMode(pageMode);
        }
      }
    }
  }

  render() {
    const { 
      viewMode,
      valCondition,
      qnaBoardList,
      pageInfo,
      detailData,

      onChangValue,
      onViewMode, 
      disQnaBoardDetail, 
      disQnaBoardList,
      addQnaBoardInfo,
      modQnaBoardInfo,
      delQnaBoardInfo,
      disQnaBoardPwChk,
      
      addQnaBoardCommentsInfo,
      modQnaBoardCommentsInfo,
      delQnaBoardCommentsInfo,

      sessionLoginInfo
    } = this.props;
    return (
      <Fragment>
        {viewMode === 'list'
        ? <QnaBoardList
            viewMode={viewMode}
            qnaBoardList={qnaBoardList}
            pageInfo={pageInfo}
            valCondition={valCondition}
            onChangValue={(dataNm, dataVal)=>onChangValue(dataNm, dataVal)}
            onViewMode={(mode)=>onViewMode(mode)}
            disQnaBoardDetail={(id,pw)=>disQnaBoardDetail(id,pw)}
            disQnaBoardList={(pageIdx)=>disQnaBoardList(pageIdx)}
            delQnaBoardInfo={delQnaBoardInfo}
            disQnaBoardPwChk={disQnaBoardPwChk}
            sessionLoginInfo={sessionLoginInfo}
          /> 
        : <QnaBoardDetail
            viewMode={viewMode}
            detailData={detailData}
            onViewMode={(mode)=>onViewMode(mode)}
            disQnaBoardDetail={(id,pw)=>disQnaBoardDetail(id,pw)}
            addQnaBoardInfo={(data)=>addQnaBoardInfo(data)}
            modQnaBoardInfo={(data)=>modQnaBoardInfo(data)}
            disQnaBoardList={(pageIdx)=>disQnaBoardList(pageIdx)}
            delQnaBoardInfo={delQnaBoardInfo}
            addQnaBoardCommentsInfo={addQnaBoardCommentsInfo}
            modQnaBoardCommentsInfo={modQnaBoardCommentsInfo}
            delQnaBoardCommentsInfo={delQnaBoardCommentsInfo}
            
            sessionLoginInfo={sessionLoginInfo}
          />
        }
      </Fragment>
    );
  }

}

export default withRouter(QnaBoard);
